var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnonymous(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.0737,
    width: 11.8519,
    height: 1.48148,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.9263,
    y: 1.48148,
    width: 4.44445,
    height: 1.48148,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.62988,
    y: 1.48148,
    width: 4.44445,
    height: 1.48148,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30.3701,
    y: 2.96296,
    width: 1.48148,
    height: 1.48148,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.14795,
    y: 2.96296,
    width: 1.48148,
    height: 1.48148,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 31.8521,
    y: 4.44444,
    width: 1.48148,
    height: 1.48148,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.6665,
    y: 4.44444,
    width: 1.48148,
    height: 1.48148,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 31.8521,
    y: 10.3704,
    width: 1.48148,
    height: 1.48148,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 31.8521,
    y: 13.3333,
    width: 1.48148,
    height: 1.48148,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 30.3701,
    y: 8.88889,
    width: 1.48148,
    height: 1.48148,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4443,
    y: 7.4074,
    width: 5.92593,
    height: 1.48148,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 22.9629,
    y: 8.88889,
    width: 4.44445,
    height: 1.48148,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 21.481,
    y: 10.3704,
    width: 2.96296,
    height: 1.48148,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4443,
    y: 13.3333,
    width: 5.92593,
    height: 1.48148,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 22.9629,
    y: 14.8148,
    width: 8.88889,
    height: 1.48148,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 21.481,
    y: 16.2963,
    width: 1.48148,
    height: 4.44445,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 21.481,
    y: 23.7037,
    width: 1.48148,
    height: 4.44445,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0371,
    y: 16.2963,
    width: 1.48148,
    height: 4.44445,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 17.0371,
    y: 23.7037,
    width: 1.48148,
    height: 4.44445,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 9.62988,
    y: 13.3333,
    width: 5.92593,
    height: 1.48148,
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 6.6665,
    y: 13.3333,
    width: 1.48148,
    height: 1.48148,
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 6.6665,
    y: 10.3704,
    width: 1.48148,
    height: 1.48148,
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 9.62988,
    y: 7.4074,
    width: 5.92593,
    height: 1.48148,
    fill: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5928,
    y: 8.88889,
    width: 4.44445,
    height: 1.48148,
    fill: "white"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5557,
    y: 10.3704,
    width: 2.96296,
    height: 1.48148,
    fill: "white"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 8.14795,
    y: 8.88889,
    width: 1.48148,
    height: 1.48148,
    fill: "white"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 8.14795,
    y: 14.8148,
    width: 8.88889,
    height: 1.48148,
    fill: "white"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1118,
    y: 25.1852,
    width: 5.92593,
    height: 2.96296,
    fill: "white"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 22.9629,
    y: 25.1852,
    width: 5.92593,
    height: 2.96296,
    fill: "white"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 18.519,
    y: 25.1852,
    width: 2.96296,
    height: 1.48148,
    fill: "white"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 22.9629,
    y: 20.7407,
    width: 1.48148,
    height: 2.96296,
    fill: "white"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5557,
    y: 20.7407,
    width: 1.48148,
    height: 2.96296,
    fill: "white"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 8.14795,
    y: 22.2222,
    width: 1.48148,
    height: 2.96296,
    fill: "white"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 9.62988,
    y: 23.7037,
    width: 1.48148,
    height: 2.96296,
    fill: "white"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 9.62988,
    y: 32.5926,
    width: 1.48148,
    height: 1.48148,
    fill: "white"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1118,
    y: 34.0741,
    width: 1.48148,
    height: 1.48148,
    fill: "white"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5928,
    y: 35.5556,
    width: 1.48148,
    height: 1.48148,
    fill: "white"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 14.0737,
    y: 37.037,
    width: 1.48148,
    height: 1.48148,
    fill: "white"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 18.519,
    y: 31.1111,
    width: 2.96296,
    height: 7.40741,
    fill: "white"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5557,
    y: 38.5185,
    width: 8.88889,
    height: 1.48148,
    fill: "white"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 30.3701,
    y: 29.6296,
    width: 1.48148,
    height: 2.96296,
    fill: "white"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 31.8521,
    y: 28.1481,
    width: 1.48148,
    height: 1.48148,
    fill: "white"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 6.6665,
    y: 28.1481,
    width: 1.48148,
    height: 1.48148,
    fill: "white"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 8.14795,
    y: 29.6296,
    width: 1.48148,
    height: 2.96296,
    fill: "white"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8882,
    y: 32.5926,
    width: 1.48148,
    height: 1.48148,
    fill: "white"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 27.4072,
    y: 34.0741,
    width: 1.48148,
    height: 1.48148,
    fill: "white"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 25.9263,
    y: 35.5556,
    width: 1.48148,
    height: 1.48148,
    fill: "white"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4443,
    y: 37.037,
    width: 1.48148,
    height: 1.48148,
    fill: "white"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8882,
    y: 23.7037,
    width: 1.48148,
    height: 2.96296,
    fill: "white"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 30.3701,
    y: 22.2222,
    width: 1.48148,
    height: 2.96296,
    fill: "white"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 33.3335,
    y: 5.92593,
    width: 1.48148,
    height: 22.2222,
    fill: "white"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 5.18457,
    y: 5.92593,
    width: 1.48148,
    height: 22.2222,
    fill: "white"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 8.14746,
    y: 17.7778,
    width: 2.96296,
    height: 1.48148,
    fill: "#FBC04E"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 9.62939,
    y: 26.6667,
    width: 1.48148,
    height: 1.48148,
    fill: "#FBC04E"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1108,
    y: 28.1482,
    width: 4.44445,
    height: 1.48148,
    fill: "#FBC04E"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 14.0737,
    y: 29.6296,
    width: 11.8519,
    height: 1.48148,
    fill: "#FBC04E"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4438,
    y: 28.1482,
    width: 4.44445,
    height: 1.48148,
    fill: "#FBC04E"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8892,
    y: 26.6667,
    width: 1.48148,
    height: 1.48148,
    fill: "#FBC04E"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8892,
    y: 17.7778,
    width: 2.96296,
    height: 1.48148,
    fill: "#FBC04E"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 6.6665,
    y: 19.2593,
    width: 5.92593,
    height: 1.48148,
    fill: "#FBC04E"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 27.4072,
    y: 19.2593,
    width: 5.92593,
    height: 1.48148,
    fill: "#FBC04E"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 8.14746,
    y: 20.7408,
    width: 2.96296,
    height: 1.48148,
    fill: "#FBC04E"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8892,
    y: 20.7408,
    width: 2.96296,
    height: 1.48148,
    fill: "#FBC04E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnonymous);
export default __webpack_public_path__ + "static/media/anonymous.9216debf1c505a00e37b7897fc940567.svg";
export { ForwardRef as ReactComponent };